const data = [
	'learningtoskate',
	'learningtoskateboard',
	'learntoskate',
	'likefatherlikeson',
];

export default data;
